import { useState } from "react";
import { CalendarIcon, X } from "lucide-react";
import { id as idLocale } from "date-fns/locale";
import { Button } from "./ui/button";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { fmtDate } from "../lib/api";

const toISO = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const fromISO = (s) => { if (!s) return undefined; const d = new Date(`${String(s).slice(0, 10)}T00:00:00`); return isNaN(d.getTime()) ? undefined : d; };

export function DatePicker({ value, onChange, placeholder = "Pilih tanggal", testid = "date-picker", className = "", clearable = true, min, max }) {
  const [open, setOpen] = useState(false);
  const selected = fromISO(value);
  const minD = fromISO(min), maxD = fromISO(max);
  const disabled = (d) => (minD && d < minD) || (maxD && d > maxD) || false;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className={`w-full justify-start font-normal ${/\bh-\d+\b/.test(className) ? "" : "h-10"} ${!selected ? "text-muted-foreground" : ""} ${className}`} data-testid={testid}>
          <CalendarIcon className="w-4 h-4 mr-2 shrink-0" />
          <span className="flex-1 text-left">{selected ? fmtDate(toISO(selected)) : placeholder}</span>
          {clearable && selected && <X className="w-3.5 h-3.5 opacity-60 hover:opacity-100" onClick={(e) => { e.stopPropagation(); onChange(""); }} data-testid={`${testid}-clear`} />}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={idLocale} selected={selected} defaultMonth={selected} disabled={disabled} onSelect={(d) => { onChange(d ? toISO(d) : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
